

export const judgeStrIncludes = (parentStr,str)=>{
    return !!parentStr.includes(str);
}

export const charConversion = (str) => {
    if(!str){return str}

    str = str.replaceAll("&mdash;", '—')
        .replaceAll("&ldquo;", '"')
        .replaceAll("&rdquo;", '"')
        .replaceAll("&middot;", '·')
        .replaceAll("&amp;", '&');
    return str;
};

export const jyeooDate = (str) => {
    if(!str){return str}

    str = str.substring(0,10).replaceAll("-", '/');
    return str;
};